/**
 * @visitproof/types - Shared TypeScript types for VisitProof
 *
 * This package contains all shared types used across the VisitProof platform:
 * - client (React web dashboard)
 * - mobile (React Native mobile app)
 * - firebase/functions (Backend serverless functions)
 */

// Base types
export * from './base';

// Auth types
export * from './auth';

// Demographics types
export * from './demographics';

// Account & business types
export * from './account';

// Supervisor types
export * from './supervisor';

// Attorney types
export * from './attorney';

// Case, parent, and child types
export * from './case';

// Assessment and goals types
export * from './assessment';

// Case management types
export * from './caseManagement';

// Visit and event types
export * from './visit';

// Report and document types
export * from './report';

// Billing types
export * from './billing';

// Messaging types
export * from './messaging';

// Dashboard types
export * from './dashboard';

// Mobile-specific types
export * from './mobile';

// Client-specific types
export * from './client';

// Firebase-specific types
export * from './firebase';

// Membership and RBAC types
export * from './membership';

// Admin Console types
export * from './admin';

// Blog types
export * from './blog';

// Sign-in sheet types (check-in kiosk app)
export * from './signInSheet';

// Canonical Firebase Storage path builders (account-scoped)
export * from './storagePaths';

// Staff engagement: welcome sequences + surveys/NPS (STAFF ONLY)
export * from './engagement';

// Business analytics, KPI monitoring, AI business-analyst (super-admin only)
export * from './analytics';
